export interface ISellerJsonEntry {
    seller_id: string;
    name: string;
    domain: string;
    seller_type: string;
}

export interface ISellersJsonEntryChange {
    published: ISellerJsonEntry;
    computed: ISellerJsonEntry;
}

export interface ISellersJsonDiff {
    publishedCount: number;
    computedCount: number;
    added: ISellerJsonEntry[];
    removed: ISellerJsonEntry[];
    changed: ISellersJsonEntryChange[];
}

export const isEmptyDiff = (diff?: ISellersJsonDiff) =>
    !diff || (diff.added.length === 0 && diff.removed.length === 0 && diff.changed.length === 0);
